<section class="input-con">
  <mat-form-field class="input-container" [formGroup]="group" [appearance]="appearance">
    <mat-label *ngIf="label">{{label}}</mat-label>
    <input #inputRef matInput
      [id]="id"
      [type]="inputType"
      [formControl]="control"
      [placeholder]="placeHolder"
      (input)="checkError()"
      (focus)="focusFunction()"
      (focusout)="focusOutFunction()"
      (change)="onInputChange()"
      (keydown)="onKeyDown($event)"
      [readOnly]="readonly"
      (wheel)="disableWheel === true ? $event.preventDefault(): $event"
      >
    <mat-icon *ngIf="preIcon && inputFocused" class="preIcon" [ngClass]="preIcon" matPrefix></mat-icon>
    <div matPrefix *ngIf="currency">
      <app-currency-icon [currency] = "currency" ></app-currency-icon>
    </div>
    <mat-hint class="hint" *ngIf="hint" [align]="hintDirection ? hintDirection : 'end'"><em [innerHTML]="hint"></em></mat-hint>
    <mat-hint *ngIf="hintLength" [align]="hintDirection ? hintDirection : 'end'">{{control.value.length}} / {{hintLength}}</mat-hint>
    <mat-error *ngIf="control.hasError('required') && control.touched">{{ errorMessage?.required || fieldRequired}}</mat-error>
    <mat-error *ngIf="control.hasError('email') && control.touched">{{errorMessage?.email}}</mat-error>
    <mat-error *ngIf="control.hasError('min') && control.touched"><span [innerHTML]="errorMessage?.min"></span></mat-error>
    <mat-error *ngIf="control.hasError('max') && control.touched"><span [innerHTML]="errorMessage?.max"></span></mat-error>
    <mat-error *ngIf="control.hasError('minlength') && control.touched">{{errorMessage?.minlength}}</mat-error>
    <mat-error *ngIf="control.hasError('maxlength') && control.touched">{{errorMessage?.maxlength}}</mat-error>
    <mat-error *ngIf="control.hasError('pattern') && control.touched">{{errorMessage?.pattern}}</mat-error>
    <mat-error *ngIf="control.hasError('custom') && control.touched">{{errorMessage?.custom}}</mat-error>
    <span class="popup-1">
      <button *ngIf="info && icon" (click)="showPopover=true" type="button" class="icon-btn" mat-icon-button>
        <mat-icon class="mat-icon" #matIcon [ngClass]="icon"></mat-icon>
      </button>
      <button *ngIf="!info && icon" type="button" class="icon-btn" mat-icon-button disabled>
        <mat-icon #matIcon [ngClass]="icon"></mat-icon>
      </button>
      <app-popover-loader *ngIf="showPopover" [show]="showPopover" [config]="{popupClass: 'input-popover', title: info?.title, desc: info?.desc, eg: info?.eg, class: router?.url?.match('advance') ? 'v3' : placeHolder?.match('Fundraiser Title') ? 'v7' : placeHolder?.match('Beneficiary Name') ? 'v8' : 'v1'}" (hideel)="showPopover = $event"></app-popover-loader>
    </span>
  </mat-form-field>
</section>
